export class LoginRequest {
  public username: string;
  public password: string;
}

export class LoginResponse {
  public success: boolean;
  public errorText: string;
  public name: string;
  public shops: Shop[];
  public links: Link[];
  public topartikelListe: Topartikel[];
  public isInfoIntern: boolean;
  public isInfoExtern: boolean;
}

export class Topartikel {
  public text: string;
  public shop: string;
  public bildUrl: string;
}

export class Link {
  public text: string;
  public url: string;
  public icon: string;
}

export class ChangePasswordRequest {
  public username: string;
  public oldPassword: string;
  public newPassword: string;
}

export class ChangePasswordResponse {
  public success: boolean;
  public errorText: string;
}

export class SendPasswordRequest {
  public email: string;
}

export class SendPasswordResponse {
  public success: boolean;
  public errorText: string;
}

export class Shop {
  public nr: string;
  public name: string;
  public logo: string;
  public kontakt: string;
  public konditionen: Kondition[];
}

export class Kondition {
  public name: string;
  public abrechnungName: string;
  public abrechnungOrg: number;
  public abrechnungMarkt: number;
  public abrechnungAbteilung: number;
  public lieferort: string;
  public kundeninfo: string;
  public dauer: number;
  public lieferzeitStunde: number;
  public lieferzeitMinute: number;
  public mo: boolean;
  public di: boolean;
  public mi: boolean;
  public do: boolean;
  public fr: boolean;
  public sa: boolean;
  public so: boolean;
}
